//https://reactjs.org/docs/faq-functions.html
import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import AuthService from "../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import Edit from "@material-ui/icons/Edit";
import { List, arrayMove } from "react-movable";

/**
 * Author Darya OREL
 * Page avec tous les mondes de compagnie
 */

class CompanyWorlds extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      modalAdd: false,
      modalEdit: false,
      idWorldEdit: "",
      nameWorldEdit: "",
      positionWorldEdit: "",
      worlds: [],
      data: [],
      world: "",
      position: "",
      smiles: "",
      widths: [],
      disableAdd: false,
      prevData: []
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitEditModal = this.handleSubmitEditModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
  }

  /**
   * Darya Orel
   * Affichage des messages d'erreurs
   * @param err erreur
   */
  notifyError(err) {
    toast.error(err);
  }

  /**
   * Darya Orel
   * Affichage des messages de success
   * @param msg message
   */
  notifySuccess(msg) {
    toast.success(msg);
  }

  
  /**
   * Darya Orel
   * Affichage des messages d'erreurs
   * @param err erreur
   */
  notifyInfo(err) {
    toast.info(err);
  }

  /**
   * Darya Orel
   * Chargement de la page
   * @param err erreur
   */
  componentDidMount() {
    this.fetchWorlds(this);
    this.getAllWorlds(this);
  }

  /**
   * Darya Orel
   * Rechargement de la page
   * @param err erreur
   */
  componentDidUpdate(prevProps) {
    if (prevProps.newFetch !== this.props.newFetch) {
      this.fetchWorlds(this);
      this.forceUpdate();
      this.getAllWorlds(this);
    }
  }

  /**
   * Darya Orel
   * Ouverture et fermeture du modal d'ajout
   */
  toggle() {
    this.setState(prevState => ({
      modalAdd: !prevState.modalAdd
    }));
  }

  /**
   * Darya Orel
   * Ouverture et fermeture du modal d'édition
   */
  toggleEditModal() {
    this.setState(prevState => ({
      modalEdit: !prevState.modalEdit
    }));
  }

  /**
   * Darya Orel
   * Récuperation de tous les mondes
   */
  getAllWorlds(thus) {
    thus.Auth.httpRequest("get", "api/world/selectAll")
      .then(datas => {
        if (Array.isArray(datas.data) || datas.data.length > 0) {
          thus.setState({
            worlds: datas.data
          });
        }
      })
      .catch(error => {
        this.notifyError("Erreur de récuperation des mondes");
      });
  }

  /**
   * Darya Orel
   * Edition d'un monde
   */
  edit(event) {
    this.setState({
      idWorldEdit: event.currentTarget.getAttribute("data-id"),
      nameWorldEdit: event.currentTarget.getAttribute("data-title"),
      positionWorldEdit: event.currentTarget.getAttribute("data-position")
    });
    this.toggleEditModal();
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Suppression d'un monde
   */
  delete(event) {
    let idToDelete = event.currentTarget.getAttribute("data-id");
    let titleToDelete = event.currentTarget.getAttribute("data-title");

    if (
      confirm(
        "Etes-vous sur de bien vouloir supprimer le monde : " + titleToDelete
      )
    ) {
      this.Auth.httpRequest(
        "delete",
        "api/companyworld/delete?companyId=" +
          this.props.params.id +
          "&worldId=" +
          idToDelete
      )
        .then(datas => {
          var msg = "Le monde a été supprimé avec succès";
          this.notifySuccess(msg);
        })
        .catch(error => {
          this.notifyError("Erreur de suppression du monde");
        })
        .finally(() => {
          this.fetchWorlds(this);
        });
    }
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Récuperation de tous les mondes de la compagnie
   */
  fetchWorlds(thus) {
    thus.Auth.httpRequest(
      "GET",
      "api/companyworld/selectWorldAndPositionForCompany?companyId=" +
        thus.props.params.id
    )
      .then(function(datas) {
        if (Array.isArray(datas.data) || datas.data.length > 0) {
          thus.setState({
            data: datas.data
          });
        }
      })
      .catch(error => this.notifyError("Erreur de récuperation des mondes"))
      .finally(() => {
        this.state.data.map((object, index) => {
          if (object.position != index + 1) {
            object.position = index + 1;
            this.Auth.httpRequest("POST", "api/companyworld/update", {
              worldId: object.worldId,
              companyId: this.props.params.id,
              position: index + 1,
              smilesNeededToUnlock: object.smilesNeededToUnlock
            });
          }
        });
        this.getAllWorlds(this);
      });
  }

  /**
   * Darya Orel
   * Récuperation du changement du champ
   */
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  /**
   * Darya Orel
   * Récuperation du changement du champ du select
   */
  handleChangeSelect() {
    var e = document.getElementById("world");
    var value = e.options[e.selectedIndex].value;
    this.setState({
      world: value
    });
  }

  /**
   * Darya Orel
   * Action lorsqu'on a cliquer sur le submit du modal d'ajout
   */
  handleSubmit(event) {
    this.Auth.httpRequest("POST", "api/companyworld/insert", {
      companyId: this.props.params.id,
      worldId: this.state.world,
      position: this.state.data.length + 1,
      smilesNeededToUnlock: this.state.smiles
    })
      .then(datas => {
        var msg = "L'ajout du monde a été réalisé avec succès";
        this.notifySuccess(msg);
        this.setState({
          modalAdd: false,
          world: "",
          position: "",
          smiles: ""
        });
      })
      .catch(error => {
        this.notifyError("Erreur d'insertion du monde");
      })
      .finally(() => {
        this.fetchWorlds(this);
      });
    //  on soumet pas vraiment le formulaire
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Action lorsqu'on a cliquer sur le submit du modal d'édition
   */
  handleSubmitEditModal(event) {
    this.Auth.httpRequest("POST", "api/companyworld/update", {
      worldId: this.state.idWorldEdit,
      companyId: this.props.params.id,
      position: this.state.positionWorldEdit,
      smilesNeededToUnlock: this.state.smiles
    })
      .then(datas => {
        var msg = "La modification du monde a été réalisée avec succès";
        this.notifySuccess(msg);
        this.setState({
          modalEdit: false,
          smiles: ""
        });
      })
      .catch(error => {
        this.notifyError("Erreur de modiication du monde");
      })
      .finally(() => {
        this.fetchWorlds(this);
      });
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Render fonction
   * @return la page à afficher
   */
  render() {
    let content, addWorldModal, editWorldModal;

    content = (
      <CardBody className="pb-0">
        <ToastContainer />
        <div>
          <List
            lockVertically
            beforeDrag={({ elements, index }) => {
              const cells = Array.from(elements[index].children);
              const widths = cells.map(
                cell => window.getComputedStyle(cell).width
              );
              this.setState({ widths });
            }}
            values={this.state.data}
            onChange={({ oldIndex, newIndex }) => {
              this.setState(prevState => ({
                prevData: prevState.data,
                data: arrayMove(prevState.data, oldIndex, newIndex)
              }));
              this.state.data.map((object, index) => {
                object.position = index + 1;
              });
              this.state.data.map((object, index) => {
                if (object.position != this.state.prevData[index].position) {
                  this.Auth.httpRequest("POST", "api/companyworld/update", {
                    worldId: object.worldId,
                    companyId: this.props.params.id,
                    position: object.position,
                    smilesNeededToUnlock: object.smilesNeededToUnlock
                  });
                }
              });
            }}
            renderList={({ children, props, isDragged }) => (
              <Table
                responsive
                striped
                bordered
                style={{
                  background: "#eaebec",
                  borderSpacing: 0,
                  cursor: isDragged ? "grabbing" : undefined
                }}
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nom</th>
                    <th>Nombre de sourires</th>
                    <th>Position</th>
                    <th>Supprimer</th>
                    <th>Éditer</th>
                  </tr>
                </thead>
                <tbody {...props}>{children}</tbody>
              </Table>
            )}
            renderItem={({ value, props, isDragged, isSelected }) => {
              const widths = isDragged ? this.state.widths : [];
              const row = (
                <tr
                  {...props}
                  style={{
                    cursor: isDragged ? "grabbing" : "grab",
                    backgroundColor:
                      isDragged || isSelected ? "#EEE" : "#fafafa"
                  }}
                  style={props.style}
                >
                  <td style={{ width: widths[0] }}>{value.worldId}</td>
                  <td style={{ width: widths[1] }}>{value.title}</td>
                  <td style={{ width: widths[2] }}>
                    {value.smilesNeededToUnlock}
                  </td>
                  <td style={{ width: widths[3] }}>{value.position}</td>
                  <td style={{ width: widths[4] }}>
                    <a
                      href="#"
                      onClick={this.delete}
                      data-id={value.worldId}
                      data-title={value.title}
                    >
                      <i className="fa fa-trash text-danger" />
                    </a>
                  </td>
                  <td style={{ width: widths[5] }}>
                    <a
                      href="#"
                      onClick={this.edit}
                      data-id={value.worldId}
                      data-title={value.title}
                      data-position={value.position}
                    >
                      <Edit />
                    </a>
                  </td>
                </tr>
              );
              return isDragged ? (
                <Table
                  style={{
                    cursor: isDragged ? "grabbing" : "grab",
                    backgroundColor:
                      isDragged || isSelected ? "#EEE" : "#fafafa"
                  }}
                  style={props.style}
                >
                  <tbody>{row}</tbody>
                </Table>
              ) : (
                row
              );
            }}
          />
        </div>
      </CardBody>
    );

    addWorldModal = (
      <div>
        <Modal
          isOpen={this.state.modalAdd}
          toggle={this.toggle}
          className="addWorldModal"
        >
          <form onSubmit={this.handleSubmit}>
            <ModalHeader toggle={this.toggle}>Ajouter un monde</ModalHeader>
            <ModalBody>
              <div>
                <label>Nom du monde:</label>
                <br />
                <select required onChange={this.handleChangeSelect} id="world">
                  <option hidden>Choissisez le monde</option>
                  {this.state.worlds.map(object => {
                    if (!this.state.data.map(d => d.id).includes(object.id)) {
                      return (
                        <option key={object.id} value={object.id}>
                          {object.title}
                        </option>
                      );
                    }
                  })}
                </select>
              </div>
              <div>
                <label>Nombre de sourires pour y accéder:</label>
                <br />
                <input
                  required
                  type="text"
                  id="smiles"
                  name="smiles"
                  value={this.state.smiles}
                  onChange={this.handleChange}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                Ajouter
              </Button>{" "}
              <Button color="secondary" onClick={this.toggle}>
                Annuler
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );

    editWorldModal = (
      <div>
        <Modal
          isOpen={this.state.modalEdit}
          toggle={this.toggleEditModal}
          className="editWorldModal"
        >
          <form onSubmit={this.handleSubmitEditModal}>
            <ModalHeader toggle={this.toggleEditModal}>
              Modifier un monde
            </ModalHeader>
            <ModalBody>
              <div>
                <h2>{this.state.nameWorldEdit}</h2>
              </div>
              <div>
                <label>Nombre de sourires pour y accéder:</label>
                <br />
                <input
                  required
                  type="text"
                  id="smiles"
                  name="smiles"
                  value={this.state.smiles}
                  onChange={this.handleChange}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                Modifier
              </Button>{" "}
              <Button color="secondary" onClick={this.toggleEditModal}>
                Annuler
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );

    return (
      <div>
        <div className="animated fadeIn">
          <br />
          <Row>
            <Col xs="12" lg="12">
              <Card>
                <CardHeader>
                  <i className="fa fa-align-justify" /> Mondes
                  <Button
                    className="pull-right"
                    color="primary"
                    onClick={this.toggle}
                    disabled={
                      this.state.data.length === this.state.worlds.length
                    }
                  >
                    <i className="fa fa-plus" /> Ajouter
                  </Button>
                </CardHeader>
                {content}
              </Card>
            </Col>
          </Row>
        </div>
        {addWorldModal}
        {editWorldModal}
      </div>
    );
  }
}

export default CompanyWorlds;



// WEBPACK FOOTER //
// ./src/views/AdminCompanies/CompanyWorlds.js